import { forwardRef, type HTMLAttributes } from "react";
import { cn } from "@/lib/utils";

interface GlassCardProps extends HTMLAttributes<HTMLDivElement> {
  /** Add the purple primary glow shadow. */
  glow?: boolean;
}

/**
 * Glassmorphism surface that reads correctly in both themes (uses the `card`
 * token at partial opacity + backdrop blur, so it's frosted-light in light
 * mode and frosted-dark in dark mode).
 */
export const GlassCard = forwardRef<HTMLDivElement, GlassCardProps>(
  ({ className, glow = false, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        // backdrop-blur is a heavy per-frame cost on iOS during scroll, so it's
        // desktop-only (md+); phones get a more opaque card instead of frosted.
        "relative rounded-2xl border border-border/60 bg-card/80 md:bg-card/60 md:backdrop-blur-xl",
        "shadow-[0_8px_40px_-12px_rgba(0,0,0,0.45)]",
        glow && "shadow-glow",
        className,
      )}
      {...props}
    />
  ),
);
GlassCard.displayName = "GlassCard";
